exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"sourceMap\":false,\"modules\":true,\"localIdentName\":\"[hash:base64:5]\",\"minimize\":true,\"discardComments\":{\"removeAll\":true}}!../../../../../node_modules/postcss-loader/lib/index.js?{\"config\":{\"path\":\"./tools/postcss.config.js\"}}!../BrandItem/BrandItem.css"), undefined);

// module
exports.push([module.id, "._2ncdY,._37QDP{position:relative}._2ncdY{cursor:pointer;color:#2196f3}", ""]);

// exports
exports.locals = {
	"root": "_37QDP",
	"all": "_2ncdY " + require("-!../../../../../node_modules/css-loader/index.js?{\"importLoaders\":1,\"sourceMap\":false,\"modules\":true,\"localIdentName\":\"[hash:base64:5]\",\"minimize\":true,\"discardComments\":{\"removeAll\":true}}!../../../../../node_modules/postcss-loader/lib/index.js?{\"config\":{\"path\":\"./tools/postcss.config.js\"}}!../BrandItem/BrandItem.css").locals["root"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/BrandsList/BrandsColumn/BrandsColumn.css
// module id = 2471
// module chunks = 24 33